import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  fonts: {
    heading: `'DM Sans', sans-serif`,
    body: `'DM Sans', sans-serif`,
  },
  colors: {
    brand: {
      50: '#e8f4f8',
      100: '#b8dfe8',
      200: '#88cad8',
      300: '#58b5c8',
      400: '#28a0b8',
      500: '#0e869e',
      600: '#0b697c',
      700: '#084d5a',
      800: '#053038',
      900: '#021416',
    },
    grid: {
      headerBg: '#1a365d',
      headerText: '#ffffff',
      rowHover: '#ebf8ff',
      groupBg: '#2d3748',
      groupText: '#ffffff',
      border: '#e2e8f0',
      doneBg: '#c6f6d5',
      heldBg: '#fed7d7',
      lowPriority: '#fefcbf',
    },
  },
  styles: {
    global: {
      body: {
        bg: '#f7fafc',
        fontSize: '13px',
      },
    },
  },
  components: {
    Tooltip: {
      baseStyle: {
        '--tooltip-bg': 'colors.gray.700',
        px: 2,
        py: 1,
        borderRadius: 'md',
        fontSize: 'xs',
        boxShadow: 'lg',
        transition: 'opacity 0.25s ease-in-out, transform 0.25s ease-in-out',
      },
      defaultProps: {
        openDelay: 1000,
        hasArrow: true,
      },
    },
    Table: {
      variants: {
        crm: {
          th: {
            bg: 'grid.headerBg',
            color: 'grid.headerText',
            fontSize: '11px',
            fontWeight: '600',
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            px: 2,
            py: 2,
            borderColor: 'grid.border',
            borderBottom: '2px solid white',
            position: 'sticky',
            top: 0,
            zIndex: 4,
          },
          td: {
            px: 2,
            py: 1,
            fontSize: '12px',
            borderColor: 'grid.border',
            position: 'relative',
          },
          tr: {},
        },
      },
    },
  },
});

export default theme;
